import CarHireUpsellOfferTile from '../CarHireOfferTile/CarHireUpsellOfferTile'
import React, { useCallback, useMemo } from 'react'
import CarHireUpsellOfferTileLoadingSkeleton from '../CarHireOfferTile/CarHireUpsellOfferTileLoadingSkeleton'
import { addToCart } from 'analytics/snowplow/events'
import { navigateToCheckout } from 'checkout/actions/navigateActions'
import { initialiseCheckout } from 'actions/CheckoutActions'
import { generateCarHireCheckoutItem } from '../CarHireCheckoutHelper'
import { useAppDispatch } from 'hooks/reduxHooks'
import moment from 'moment'
import { take } from 'lib/array/arrayUtils'
import useCarHireList from 'hooks/CarHire/useCarHireList'
import useOrderItemsEligibleForCarHireBundle from 'hooks/CarHire/useOrderItemsEligibleForCarHireBundle'
import * as Analytics from 'analytics/analytics'
import CarHireBundledUpcomingOrderCarouselWrapper from './CarHireBundledUpcomingOrderCarouselWrapper'

interface Props {
  order: App.Order;
  showOfferBookNowButton?: boolean
  variant?: 'card' | 'full-width'
}

function CarHireBundledUpcomingOrderCarousel(props: Props) {
  const { order, variant = 'full-width', showOfferBookNowButton } = props

  const { place, filters } = useOrderItemsEligibleForCarHireBundle(order.id)

  const dispatch = useAppDispatch()

  const carHireList = useCarHireList(filters, 0)

  const offersPreview = useMemo(() => take(carHireList.vehicles, 6), [carHireList.vehicles])

  const onGoToCheckout = useCallback((offer: App.CarHireOffer) => {
    if (filters) {
      const [pickUpDate, pickUpTime] = moment.utc(carHireList.pickUp.date).format('YYYY-MM-DD|HH:mm').split('|')
      const [dropOffDate, dropOffTime] = moment.utc(carHireList.dropOff.date).format('YYYY-MM-DD|HH:mm').split('|')

      const item = generateCarHireCheckoutItem(offer, {
        dropOffDate,
        dropOffTime,
        dropOffLocation: place?.canonicalName,
        dropOffLocationId: place?.id || '',
        pickUpLocation: place?.canonicalName,
        pickUpLocationId: place?.id || '',
        pickUpDate,
        pickUpTime,
        ageCategory: filters.driversAgeCategory || 2,
        age: filters.driversAge || 25,
        isPickUpAtAirport: !!filters.isPickUpAtAirport,
        resultsTimestamp: carHireList.timestamp || 0,
        bundledOrderId: order.id,
      })

      dispatch(initialiseCheckout([item]))
      Analytics.trackEvent(addToCart())
      dispatch(navigateToCheckout())
    }
  }, [dispatch, filters, place, carHireList, order.id])

  return <CarHireBundledUpcomingOrderCarouselWrapper variant={variant}>
    {carHireList.fetching && <>
      <CarHireUpsellOfferTileLoadingSkeleton />
      <CarHireUpsellOfferTileLoadingSkeleton />
      <CarHireUpsellOfferTileLoadingSkeleton />
      <CarHireUpsellOfferTileLoadingSkeleton />
    </>}
    {!carHireList.fetching && offersPreview.map(offer => (
      <CarHireUpsellOfferTile key={offer.id} offer={offer} onOfferClick={onGoToCheckout} showBookNow={showOfferBookNowButton} />
    ))}
  </CarHireBundledUpcomingOrderCarouselWrapper>
}

export default CarHireBundledUpcomingOrderCarousel
